import { apolloSpaceInlineHalfX } from "@nexthink/apollo-tokens";
import styled from "styled-components";
import { getValueFromPixelString } from "../../utils/TokenHelpers";
import ImageFlag from "./flag.svg";
import ImageFlagBorder from "./flag-border.svg";
export const StyledFlagContainer = styled.span.withConfig({ displayName: "StyledFlagContainer_APC-7281-productShell", componentId: "sc-1fo9fr3" })(() => ({
    display: "contents",
    position: "relative",
    width: "14px",
    height: "10px",
    "& > svg": {
        marginRight: `${getValueFromPixelString(apolloSpaceInlineHalfX) + getValueFromPixelString(apolloSpaceInlineHalfX) / 2}px`,
    },
}));
export const BorderFlag = styled(ImageFlagBorder).withConfig({ displayName: "BorderFlag_APC-7281-productShell", componentId: "sc-d3zutz" })(({ theme, disabled }) => {
    return Object.assign({}, (disabled && {
        path: {
            stroke: theme.colors.apolloColorFillColorTagDisabled,
        },
    }));
});
const getBackgroundColor = (theme, color, disabled) => {
    if (disabled && color) {
        return theme.colors.apolloColorFillColorTagDisabled;
    }
    switch (color) {
        case "red":
            return theme.colors.apolloColorVizRed;
        case "yellow":
            return theme.colors.apolloColorVizYellow;
        case "green":
            return theme.colors.apolloColorVizGreen;
        case "blue":
            return theme.colors.apolloColorVizValue;
        case "purple":
            return theme.colors.apolloColorVizValue2;
        case "violet":
            return theme.colors.apolloColorVizValue6;
        case "gray":
            return theme.colors.apolloColorVizValue5;
        default:
            return "transparent";
    }
};
export const StyledFlag = styled(ImageFlag).withConfig({ displayName: "StyledFlag_APC-7281-productShell", componentId: "sc-2fa7op" })(({ theme, color, disabled }) => {
    return {
        path: {
            fill: getBackgroundColor(theme, color, disabled),
        },
    };
});
//# sourceMappingURL=ColorFlag.style.js.map